type GeocoderComponent = google.maps.GeocoderAddressComponent;

export interface ExtractedAddressComponents {
  street_number?: string;
  route?: string;
  neighborhood?: string;
  locality?: string;
  sublocality_level_2?: string;
  sublocality_level_1?: string;
  administrative_area_level_3?: string;
  administrative_area_level_2?: string;
  administrative_area_level_1?: string;
  country?: {
    short_name: string;
    long_name: string;
  };
  postal_code?: string;
}

const desiredAddressTypes = [
  'street_number',
  'route',
  'neighborhood',
  'locality',
  'sublocality_level_2',
  'sublocality_level_1',
  'administrative_area_level_3',
  'administrative_area_level_2',
  'administrative_area_level_1',
  'country',
  'postal_code',
];

export const extractAddressComponents = (addressComponents: GeocoderComponent[]): ExtractedAddressComponents => {
  const components: ExtractedAddressComponents = {};

  addressComponents.forEach((component) => {
    const addressType = component.types.find((type) => desiredAddressTypes.includes(type));

    if (addressType === 'country') {
      components.country = {
        short_name: component.short_name,
        long_name: component.long_name,
      };
    } else if (addressType) {
      components[addressType] = component.long_name;
    }
  });

  return components;
};
